import React, { useState, FC, useEffect } from "react";
import { Link } from "gatsby";
import { User } from "../../../models/user";
import Button from "../../common/button/button";

interface LikesTabProps {
  user: User;
}

const LikesTab: FC<LikesTabProps> = ({ user }) => {
  return (
    <div
      className="flex flex-col space-y-16 md:space-y-28 pt-16 md:pt-64"
      style={{ minHeight: "60vh" }}
    >
      <div className="flex flex-row justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          height="48"
          width="48"
        >
          <path
            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
            fill="url(#like_grad)"
          />
          <defs>
            <linearGradient
              id="like_grad"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#FF4041" />
              <stop offset="29.69%" stopColor="#FF6190" />
              <stop offset="57.81%" stopColor="#FF8B4B" />
              <stop offset="100%" stopColor="#85D6F7" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="flex flex-row justify-center">
        <h2 className="text-dark-white-64">Likes are coming soon!</h2>
      </div>
    </div>
  );
};

export default LikesTab;
